/**
 * Страница пользователя: редактор комнат проекта (projectroomeditor).
 *
 * Маркер инициализации — наличие #add-room-trigger.
 * Конфиг (csrf, projectId, route, словари переводов) — window.projectRoomEditorConfig.
 *
 * Функционал:
 *   - добавление комнаты (модалка-селект → AJAX);
 *   - подтверждение удаления комнаты (кастомная модалка);
 *   - валидация формы добавления (legacy-форма, может быть на странице).
 */

function init() {
    if (!document.getElementById('add-room-trigger')) return;

    const config = window.projectRoomEditorConfig;
    if (!config) {
        console.error('[project-room-editor] window.projectRoomEditorConfig not found');
        return;
    }

    const $ = window.jQuery || window.$;
    if (!$) {
        console.error('[project-room-editor] jQuery not loaded');
        return;
    }
    const showToast = window.showToast || function () {};
    // showSelectModal/showInputModal читаем из window в момент клика, а не здесь:
    // модуль dialogs импортируется в app.js позже этого модуля, и на этапе init()
    // эти функции ещё не присвоены window (гонка порядка загрузки).

    $(() => {
        // Flash-сообщения, выставленные сервером (см. config.flash)
        if (config.flash && config.flash.success) {
            showToast('success', config.flash.success);
        }
        if (config.flash && Array.isArray(config.flash.errors)) {
            config.flash.errors.forEach(err => showToast('error', err));
        }

        // Кнопка "Добавить комнату" → модалка-селект
        $('#add-room-trigger').on('click', function (e) {
            e.preventDefault();

            const showSelectModal = window.showSelectModal;
            if (typeof showSelectModal !== 'function') {
                console.error('[project-room-editor] showSelectModal is not available');
                return;
            }

            showSelectModal({
                title: config.i18n.addRoom,
                placeholder: '',
                items: config.roomOptions,
                confirmText: config.i18n.addRoomBtn,
                cancelText: config.i18n.cancel,
            }).then(selectedRoom => {
                if (!selectedRoom) return;

                if (selectedRoom === 'other') {
                    const showInputModal = window.showInputModal;
                    showInputModal({
                        title: config.i18n.enterRoomName,
                        placeholder: '',
                        confirmText: config.i18n.addRoomBtn,
                        cancelText: config.i18n.cancel,
                    }).then(customName => {
                        if (customName) addRoom(customName);
                    });
                } else {
                    addRoom(selectedRoom);
                }
            });
        });

        function addRoom(roomName) {
            $.ajax({
                url: config.routes.addRoom,
                method: 'POST',
                data: {
                    _token: config.csrfToken,
                    project_id: config.projectId,
                    name: roomName,
                    room_type: roomName,
                },
                success() {
                    showToast('success', config.i18n.roomCreated);
                    setTimeout(() => window.location.reload(), 1000);
                },
                error() {
                    showToast('error', config.i18n.errorCreatingRoom);
                },
            });
        }

        // Модалка подтверждения удаления комнаты
        let deleteRoomId = null;

        window.openDeleteRoomModal = function (roomId, roomName) {
            deleteRoomId = roomId;
            $('#delete-room-name').text(roomName);
            $('#deleteRoomModal').fadeIn(200);
        };

        window.closeDeleteRoomModal = function () {
            $('#deleteRoomModal').fadeOut(200);
            deleteRoomId = null;
            const $btn = $('#confirm-delete-room-btn');
            $btn.prop('disabled', false).text($btn.data('original-text') || config.i18n.delete);
        };

        $('#deleteRoomModal').on('click', function (e) {
            if (e.target === this) window.closeDeleteRoomModal();
        });

        $('#confirm-delete-room-btn').on('click', async function () {
            if (!deleteRoomId) return;
            $(this).prop('disabled', true).text(config.i18n.loading);
            try {
                const resp = await fetch('/removeroom/' + deleteRoomId, {
                    method: 'DELETE',
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                    },
                });
                if (resp.ok || resp.redirected) {
                    window.location.reload();
                } else {
                    if (window.showToast) window.showToast('error', config.i18n.errorDeleting || 'Error');
                    window.closeDeleteRoomModal();
                }
            } catch (e) {
                if (window.showToast) window.showToast('error', config.i18n.errorDeleting || 'Error');
                window.closeDeleteRoomModal();
            }
        });

        $('.tools_cell_delete_item').on('click', function (e) {
            e.preventDefault();
            window.openDeleteRoomModal($(this).data('room-id'), $(this).data('room-name'));
        });

        // Legacy-форма добавления (если присутствует на странице)
        $('#select_room_to_project').on('change', function () {
            const selectedValue = $(this).val();
            const nameInput = $('input[name="name"]');

            if (selectedValue === 'other') {
                nameInput.show().val('').prop('required', true).focus();
            } else if (selectedValue !== '') {
                nameInput.hide().val(selectedValue).prop('required', false);
            } else {
                nameInput.hide().val('').prop('required', false);
            }
        });

        $('#add-room-form').on('submit', function (e) {
            const selectValue = $('#select_room_to_project').val();
            const nameValue = $('input[name="name"]').val();

            if (!selectValue || (selectValue === 'other' && !nameValue)) {
                e.preventDefault();
                if (!selectValue) {
                    showToast('error', config.i18n.needToSelectRoom);
                } else {
                    showToast('error', config.i18n.putRoomName);
                }
                return false;
            }
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
